import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';

import { DownloadDialogComponent } from '../download-dialog/download-dialog.component';

@Component({
  selector: 'app-download-button',
  templateUrl: './download-button.component.html',
  styleUrls: ['./download-button.component.scss'],
})
export class DownloadButtonComponent {
  private readonly dialog = inject(MatDialog);
  private readonly translate = inject(TranslateService);

  labels = {
    title: '',
    download: '',
  };

  constructor() {
    this.translate
      .get(['downloadButton.title', 'downloadButton.download'])
      .subscribe((translations) => {
        this.labels.title = translations['downloadButton.title'];
        this.labels.download = translations['downloadButton.download'];
      });
  }

  openDialog() {
    this.dialog.open(DownloadDialogComponent, {
      width: '540px',
      data: { message: 'Hello!' },
    });
  }
}
